import { AnyAction } from "redux";

import { myFleetActions } from "../reducer/reducer";

export const setSearchValue = (value: string): AnyAction =>
  myFleetActions.setSearchValue(value);
